(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/coupon-subscriber.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/coupon-subscriber.js');
"use strict";


const {
  useContext,
  useCallback
} = React;
const {
  actions,
  PlayContext
} = svs.racing_game.components.playContext;
const {
  useSocket
} = svs.components.lbUtils.socket;
const {
  normalize
} = svs.racing.raceService.utils;
const {
  gametypeHasIoDistribution
} = svs.racing.common.util;
const {
  subProductIdToGameType
} = svs.racing.common.constants;
const UseSocketComp = _ref => {
  let {
    path,
    onUpdate
  } = _ref;
  useSocket(path, onUpdate);
  return null;
};
const CouponSubscriber = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    race,
    raceDispatch
  } = useContext(PlayContext);
  const onRaceMessage = useCallback(raceMessage => raceMessage && raceMessage.race && raceDispatch(actions.updateRace(normalize.normalizeRace(raceMessage.race))), [raceDispatch]);
  const onWinoddsMessage = useCallback(winoddsMessage => winoddsMessage && winoddsMessage.race && raceDispatch(actions.updateWinodds(normalize.normalizeWinoddsParticipanstInfo(normalize.normalizeWinOdds(winoddsMessage.race)))), [raceDispatch]);
  const onDistributionMessage = useCallback(distributionMessage => {
    if (distributionMessage && distributionMessage.distribution) {
      if (distributionMessage.userProduct === 'Rx1w') {
        raceDispatch(actions.updateDistribution(normalize.normalizeDistribution(distributionMessage.distribution, distributionMessage.userProduct)));
      } else {
        raceDispatch(actions.updateIoDistribution(normalize.normalizeDistribution(distributionMessage.distribution, distributionMessage.userProduct)));
      }
    }
  }, [raceDispatch]);
  const onShowoddsMessage = useCallback(showoddsMessage => showoddsMessage && showoddsMessage.race && raceDispatch(actions.updateShowodds(normalize.normalizeShowOdds(showoddsMessage.race))), [raceDispatch]);
  const userProducts = ['Rx1w'];
  race.draws.forEach(draw => {
    if (gametypeHasIoDistribution(subProductIdToGameType[draw.userProduct.toUpperCase()])) {
      userProducts.push(draw.userProduct);
    }
  });
  return React.createElement(React.Fragment, null, React.createElement(UseSocketComp, {
    onUpdate: onRaceMessage,
    path: "/racing/1/race/".concat(race.raceId)
  }), React.createElement(UseSocketComp, {
    onUpdate: onWinoddsMessage,
    path: "/racing/1/race/".concat(race.raceId, "/winodds")
  }), userProducts.map(userProduct => React.createElement(UseSocketComp, {
    key: userProduct,
    onUpdate: onDistributionMessage,
    path: "/racing/2/race/".concat(race.raceId, "/distribution?userProduct=").concat(userProduct)
  })), React.createElement(UseSocketComp, {
    onUpdate: onShowoddsMessage,
    path: "/racing/1/race/".concat(race.raceId, "/showodds")
  }), children);
};
svs.racing_game.components.play.CouponSubscriber = CouponSubscriber;

 })(window);